import { useStore } from 'vuex';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

/**
 * Composable para gestionar la API de tipos de bancos (master)
 * @returns {Object} - Métodos para gestionar tipos de bancos
 */
export function useTypeBanksAPI() {
  const store = useStore();

  /**
   * Obtiene la lista de tipos de bancos nacionales
   * @returns {Promise<Array>} - Lista de tipos de bancos
   */
  const getTypeBanks = async () => {
    const params = {
      url: "master/type_banks/all",
      params: {
        active: 1,
        order_by: "id",
        order_value: "desc",
      },
    };

    try {
      const response = await store.dispatch('getData', params);
      if (response.code === 200) {
        return response.data;
      }
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al cargar los bancos nacionales",
        icon: "error",
        showConfirmButton: true,
      });
      return [];
    } catch (error) {
      console.error('Error loading type banks:', error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al cargar los bancos nacionales",
        icon: "error",
        showConfirmButton: true,
      });
      return [];
    }
  };

  return {
    getTypeBanks,
  };
}
